import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Draft from './draft';
class AddressDetails extends Component {    
    render(){
        const {contact} =this.props.lunchObj.persons[0]
        return(<div>
            <div className="row">
                <div className="col-md-12 form-group" style={{marginBottom:'0px'}}>
                    <p><strong><Trans>Contact Info</Trans></strong></p>
                </div>
            </div>                      
            <div className="row">
                <div className="form-row">
                    <div className=" col-md-12 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>Address 1</Trans></label>
                        <input type="text" className="form-control" name="street1"
                         value={contact.street1} placeholder="" onChange={(e)=>{
                             this.props.onAddressChange(e.target.name,e.target.value);
                         }}/>
                    </div>
                    <div className="col-md-12 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>Address 2</Trans></label>
                        <input type="text" className="form-control" name="street2"
                        value={contact.street2} placeholder="" onChange={(e)=>{
                            this.props.onAddressChange(e.target.name,e.target.value);
                         }}/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-md-6 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>City</Trans></label>   
                        <input type="text" name="city" value={contact.city} className="form-control" placeholder="" onChange={(e)=>{
                             this.props.onAddressChange(e.target.name,e.target.value);
                         }}/>
                    </div> 
                    <div className="col-md-6 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>State</Trans></label>
                        <select className="form-control" placeholder=" " name="state" value={contact.state} onChange={(e)=>{
                             this.props.onAddressChange(e.target.name,e.target.value);
                         }}>
                            <option value=""></option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>
                        </select>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-md-6 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>Zip</Trans></label>
                        <input type="text" className="form-control" name="zip" placeholder="" value={contact.zip} onChange={(e)=>{
                             this.props.onAddressChange(e.target.name,e.target.value);
                         }}/>
                    </div>
                    <div className="col-md-6 form-group" style={{margin:'2px 0px'}}>
                        <label><Trans>Mobile</Trans></label>
                        <input type="text" className="form-control" name="phone" placeholder="" value={contact.phone} onChange={(e)=>{
                             this.props.onAddressChange(e.target.name,e.target.value);
                         }}/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        let assistProgram=this.props.lunchObj.assistancePrograms.some(function (e) {
                            return e.isApplicable;
                        });
                        if(assistProgram){
                            this.props.jumpToStep(4);
                        }else{
                            let selectedStudents=this.props.lunchObj.studentList.filter((student)=>{
                                    return student.isSelected
                                });
                            let everyOneFosterSelected=selectedStudents.every((stu)=>
                                {return stu.liveUnderFosterCare});
                            if(everyOneFosterSelected){
                                this.props.jumpToStep(5);
                            }else{
                                if(this.props.lunchObj.isIncomeAfter===false){
                                this.props.jumpToStep(7);
                            }else{
                                this.props.jumpToStep(11);
                            }
                            }                          
                        }
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                                this.props.jumpToStep(13);
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} />
                </div>
          </div>
        </div>)
    }
}
export default AddressDetails


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/addressDetails.jsx